import React from "react";
import wrap from "../../utils/wrap";
import Overlay from "../Overlay";
import UploadFont from "./UploadFont";
import { PlusIcon } from "../../admin/Icons";
import { Form, Select, Divider } from "antd";
import FontPicker from "./FontPicker";
import { usePrefs } from "../../utils/Prefs";


export default function SiteText(props) {

    // Destructure
    const [prefs, setPrefs] = usePrefs(); 
    const { changed = false, row = false, data = {}, setData = () => { } } = props;
    const { base_font = 0, base_font_size = 0, fonts = [] } = data;

    const save = (_val, _key) => {
        setData({ ...data, [_key]: _val });
        setPrefs({...prefs, "changed" : true})
    }

    const draw = () => {
        return (
            <div>
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BASE FONT</Divider>
                <FontPicker no_default value={base_font} onChange={(_v) => save(_v, "base_font")} fonts={fonts} />
                <div className="shim" /> <div className="shim" />
                {/* <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BASE FONT SIZE</Divider>
                <Select value={base_font_size} onChange={(e) => save(e, "base_font_size")} style={{ "borderBottom": "1px solid #eee", "width": "100%" }} bordered={true}>
                    <Select.Option value={14}><small>14px</small></Select.Option>
                    <Select.Option value={16}><small>16px</small></Select.Option>
                    <Select.Option value={18}><small>18px</small></Select.Option>
                </Select> */}
            </div>
        )
    }

    const drawRow = () => {
        return (
            <div className="float-flex">
                <span style={{ "fontWeight": "bold" }}>
                    <wrap.tags color="#1890ff" value={(changed)}>Site text</wrap.tags>
                </span>
            </div>
        )
    }


    return (row) ? drawRow() : draw();

}